import type { ComponentChildren } from 'preact'
import { useNonProspectDomains, type NonProspectDomainsScope } from '@/hooks/useNonProspectDomains'
import { NonProspectDomainsPanel } from './NonProspectDomainsPanel'

interface Props {
  scope: NonProspectDomainsScope
  readOnly?: boolean
  bare?: boolean
  scopeControl?: ComponentChildren
  onBusyChange?: (busy: boolean) => void
}
export function NonProspectDomainsCard({ scope, readOnly = false, scopeControl, onBusyChange }: Props) {
  const { view, loading, error, save, preview, reload } = useNonProspectDomains(scope)
  if (loading) return <p class="p-6 text-sm text-slate-500" role="status">Loading non-prospect domains…</p>
  if (error || !view) return <div class="p-6 text-sm" role="alert"><p>{error ?? 'Unable to load non-prospect domains.'}</p><button type="button" onClick={reload}>Try again</button></div>
  return <NonProspectDomainsPanel view={view} onSave={save} onPreview={preview} onReload={reload} level={scope.level} readOnly={readOnly} scopeControl={scopeControl} onBusyChange={onBusyChange}/>
}
